/**
 * Cards Layout Index
 * 
 * Exports the cards layout configuration.
 */

import { CardsLayout } from './CardsLayout';
import { CardsOptions } from './CardsOptions';
import type { LayoutConfig, CardsLayoutOptions } from '../types';

export const cardsLayout: LayoutConfig<CardsLayoutOptions> = {
    id: 'cards',
    name: 'Cards',
    icon: 'grid_view',
    component: CardsLayout,
    optionsComponent: CardsOptions,
    headerShadow: false,
};

export { CardsLayout } from './CardsLayout';
export { CardsOptions } from './CardsOptions';
